import { EventStreamMarshaller } from "./EventStreamMarshaller";
/** NodeJS event stream utils provider */
export var eventStreamSerdeProvider = function (options) { return new EventStreamMarshaller(options); };
